import firebase from "firebase/app";
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from './firebase';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login() {

    const history = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const signIn = e => {
        e.preventDefault();

        //some fancy firebase login.....
        firebase.auth().signInWithEmailAndPassword(email, password)
            .then(auth => {
                history('/');
            })
            .catch(error => alert(error.message))

    }

    const register = e => {
        e.preventDefault();

        //do some fancy firebase register
        firebase.auth().createUserWithEmailAndPassword(email, password)
            .then((auth) => {
                //successfully created a new user
                if (auth) {
                    history('/');
                }
            })
            .catch(error => alert(error.message))
    }


    return (
        <div className='login'>
            <Link to='/'>
                <img
                    className='login__logo'
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png" alt="" />
            </Link>
            <div className="login__container">
                <h1>Sign In</h1>
                <form action="">
                    <h5>E-mail</h5>
                    <input type="text" value={email} onChange={e => setEmail(e.target.value)} />

                    <h5>Password</h5>
                    <input type="password" value={password} onChange={e => setPassword(e.target.value)} />

                    <button
                        onClick={signIn}
                        type='submit'
                        className='login__signInButton'>Sign In</button>
                </form>

                <p>By continuing, you agree to Amazon's Conditions of Use and Privacy Notice.</p>

                <button
                    onClick={register}
                    type='submit'
                    className='login__registerButton'>Create your Amazon Account</button>
            </div>

        </div>
    )
}

export default Login